/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import '@arco-design/web-react/dist/css/arco.css';

const MainPage = lazy(() => import('./pages/MainPage'));

function App() {
  console.warn('运行问题可参考 README 内容进行排查');
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            加载中...
          </div>
        }
      >
        <Routes>
          <Route path="/">
            <Route index element={<MainPage />} />
            <Route path="/*" element={<MainPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
